//
//  SDKWorkspaceNPMRegistrySettings.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { WorkspaceNPMRegistryAuthType } from "../enums/SDKWorkspaceNPMRegistryAuthType";
import { WorkspaceNPMRegistryType } from "../enums/SDKWorkspaceNPMRegistryType";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Object Definition
export class WorkspaceNPMRegistrySettings {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d, _e;
        this.registryType = model.registryType;
        this.authType = model.authType;
        this.enabledScopes = model.enabledScopes;
        this.registryUrl = model.registryUrl;
        this.proxyUrl = model.proxyUrl;
        this.username = (_a = model.username) !== null && _a !== void 0 ? _a : null;
        this.customRegistryUrl = (_b = model.customRegistryUrl) !== null && _b !== void 0 ? _b : null;
        this.bypassProxy = (_c = model.bypassProxy) !== null && _c !== void 0 ? _c : null;
        this.accessToken = (_d = model.accessToken) !== null && _d !== void 0 ? _d : null;
        this.password = (_e = model.password) !== null && _e !== void 0 ? _e : null;
    }
    static initial() {
        return new WorkspaceNPMRegistrySettings({
            registryType: WorkspaceNPMRegistryType.npmJS,
            authType: WorkspaceNPMRegistryAuthType.basic,
            enabledScopes: [],
            registryUrl: "",
            proxyUrl: "",
        });
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    toUpdateObject() {
        var _a, _b, _c, _d, _e;
        return {
            registryType: this.registryType,
            authType: this.authType,
            enabledScopes: this.enabledScopes,
            username: (_a = this.username) !== null && _a !== void 0 ? _a : undefined,
            customRegistryUrl: (_b = this.customRegistryUrl) !== null && _b !== void 0 ? _b : undefined,
            bypassProxy: (_c = this.bypassProxy) !== null && _c !== void 0 ? _c : undefined,
            accessToken: (_d = this.accessToken) !== null && _d !== void 0 ? _d : undefined,
            password: (_e = this.password) !== null && _e !== void 0 ? _e : undefined,
        };
    }
    toRemote() {
        var _a, _b, _c, _d, _e;
        return {
            registryType: this.registryType,
            authType: this.authType,
            username: (_a = this.username) !== null && _a !== void 0 ? _a : undefined,
            customRegistryUrl: (_b = this.customRegistryUrl) !== null && _b !== void 0 ? _b : undefined,
            enabledScopes: this.enabledScopes,
            bypassProxy: (_c = this.bypassProxy) !== null && _c !== void 0 ? _c : undefined,
            accessToken: (_d = this.accessToken) !== null && _d !== void 0 ? _d : undefined,
            password: (_e = this.password) !== null && _e !== void 0 ? _e : undefined,
            registryUrl: this.registryUrl,
            proxyUrl: this.proxyUrl,
        };
    }
    toTransport() {
        return this.toRemote();
    }
    static fromTransport(model) {
        return new WorkspaceNPMRegistrySettings(model);
    }
}
